import { useForm } from "react-hook-form";
import { FORGET_PASSWORD, fetchData } from "../../Service";
import { toast } from "react-toastify";
import { useContext } from "react";
import { Context } from "../../Context";

const ForgetPassword = () => {
	const [context, setContext] = useContext(Context);
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const submitDetails = (data) => {
		fetchData(FORGET_PASSWORD, "POST", data, false, false, (res) => {
			if (res.status) {
				toast.success("Password reset link has been sent to your email");

				reset();
				window.$("#forgetPasswordModal").modal("hide");
			} else {
				toast.error(res?.message);
			}
		});
	};

	return (
		<div
			className="modal fade pe-0"
			id="forgetPasswordModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabIndex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content apply-job-form">
					<button
						className="btn-close"
						type="button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={() => {
							reset();
						}}
					></button>
					<div className="modal-header d-block text-center border-bottom-0">
						<a href="#!">
							<img title="NRIS" src="/assets/images/logo.png" width="150px" alt="..." />
						</a>
						<h5 className="text-brand-1 text-capitalize">Reset Password</h5>
					</div>
					<div className="modal-body px-4 pb-0">
						<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(submitDetails)}>
							<div className="row">
								<div className="col-12 mb-2">
									<label>
										Please enter email address to send reset password link. <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.email_id && "is-invalid"}`}
										placeholder="Email"
										maxLength={120}
										type="email"
										{...register("email_id", {
											required: { value: true, message: "Email is required." },
											pattern: {
												value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
												message: "Email is invalid.",
											},
										})}
									/>
									{errors.email_id && <div className="invalid-feedback">{errors.email_id.message}</div>}
								</div>
							</div>
							<div className=" d-block text-center mt-3 mb-2">
								<button className="btn btn-default hover-up m-auto" type="submit" name="login">
									Send Request
								</button>
							</div>
						</form>
						<p className="color-black font12 text-center mb-2">
							Already have an account?{" "}
							<a href="#!" className="text-primary " data-bs-toggle="modal" data-bs-target="#loginModal" data-bs-dismiss="modal">
								Sign In
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ForgetPassword;
